<script lang="ts">
export interface ProseH4Props {
  id?: string
  class?: any
}

export interface ProseH4Slots {
  default: (props?: object) => unknown
}
</script>

<script setup lang="ts">
const props = defineProps<ProseH4Props>()
defineSlots<ProseH4Slots>()
</script>

<template>
  <h4
    :id
    class="my-1 text-base font-semibold"
    :class="props.class"
  >
    <a
      v-if="id"
      :href="`#${id}`"
    >
      <slot />
    </a>
    <slot v-else />
  </h4>
</template>
